// This file is auto-generated by @buzola/vite-plugin. Do not edit.
/* eslint-disable */

import { lazy, type ComponentType } from 'react';
import { buildRouteTree } from '@buzola/router';
import type { RouteConfig } from '@buzola/router';

import Route0 from './routes/_layout';
import Route1 from './routes/app/_layout';
const Route2 = () => import('./routes/app/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
import Route3 from './routes/app/org/_layout';
import Route4 from './routes/app/org/instances/detail/debug/_layout';
const Route5 = () => import('./routes/app/org/instances/detail/debug/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route6 = () => import('./routes/app/org/instances/detail/debug/agents-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route7 = () => import('./routes/app/org/instances/detail/debug/agents').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route8 = () => import('./routes/app/org/instances/detail/debug/communication').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route9 = () => import('./routes/app/org/instances/detail/debug/dashboard').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route10 = () => import('./routes/app/org/instances/detail/debug/events').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route11 = () => import('./routes/app/org/instances/detail/debug/files').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route12 = () => import('./routes/app/org/instances/detail/debug/llm-call').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route13 = () => import('./routes/app/org/instances/detail/debug/llm-calls').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route14 = () => import('./routes/app/org/instances/detail/debug/logs').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route15 = () => import('./routes/app/org/instances/detail/debug/mailbox').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route16 = () => import('./routes/app/org/instances/detail/debug/services').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route17 = () => import('./routes/app/org/instances/detail/debug/timeline').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route18 = () => import('./routes/app/org/instances/detail/debug/user-chat').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route19 = () => import('./routes/app/org/bundles/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route20 = () => import('./routes/app/org/bundles/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route21 = () => import('./routes/app/org/instances/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route22 = () => import('./routes/app/org/instances/detail/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route23 = () => import('./routes/app/org/instances/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route24 = () => import('./routes/app/org/members').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route25 = () => import('./routes/app/org/resources/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route26 = () => import('./routes/app/org/resources/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route27 = () => import('./routes/app/org/settings/api-key-create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route28 = () => import('./routes/app/org/settings/api-keys').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route29 = () => import('./routes/app/org/settings/general').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route30 = () => import('./routes/app/org/settings/github').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route31 = () => import('./routes/app/org/settings/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route32 = () => import('./routes/app/org/settings/providers').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route33 = () => import('./routes/app/org/settings/webhooks').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route34 = () => import('./routes/app/org/usage').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
import Route35 from './routes/app/admin/_layout';
const Route36 = () => import('./routes/app/admin/api-keys').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route37 = () => import('./routes/app/admin/organization-create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route38 = () => import('./routes/app/admin/organization-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route39 = () => import('./routes/app/admin/organization-members').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route40 = () => import('./routes/app/admin/organizations').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route41 = () => import('./routes/app/admin/session-stats').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route42 = () => import('./routes/app/admin/template-create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route43 = () => import('./routes/app/admin/template-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route44 = () => import('./routes/app/admin/templates').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route45 = () => import('./routes/app/admin/users').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
import Route46 from './routes/login/_layout';
const Route47 = () => import('./routes/login/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route48 = () => import('./routes/login/password-reset').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route49 = () => import('./routes/login/reset-request-success').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route50 = () => import('./routes/login/reset-request').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;

// Module augmentation for type-safe page-centric routing
declare module '@buzola/router' {
  interface BuzolaPageMap {
    'app': {};
    'app/org/instances/detail/debug': { organizationId: string; id: string };
    'app/org/instances/detail/debug/agents-detail': { organizationId: string; id: string; sessionId: string; agentId: string };
    'app/org/instances/detail/debug/agents': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/communication': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/dashboard': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/events': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/files': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/llm-call': { organizationId: string; id: string; sessionId: string; callId: string };
    'app/org/instances/detail/debug/llm-calls': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/logs': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/mailbox': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/services': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/timeline': { organizationId: string; id: string; sessionId: string };
    'app/org/instances/detail/debug/user-chat': { organizationId: string; id: string; sessionId: string };
    'app/org/bundles/edit': { organizationId: string; id: string };
    'app/org/bundles': { organizationId: string };
    'app/org/instances/create': { organizationId: string };
    'app/org/instances/detail': { organizationId: string; id: string };
    'app/org/instances': { organizationId: string };
    'app/org/members': { organizationId: string };
    'app/org/resources/edit': { organizationId: string; id: string };
    'app/org/resources': { organizationId: string };
    'app/org/settings/api-key-create': { organizationId: string };
    'app/org/settings/api-keys': { organizationId: string };
    'app/org/settings/general': { organizationId: string };
    'app/org/settings/github': { organizationId: string };
    'app/org/settings': { organizationId: string };
    'app/org/settings/providers': { organizationId: string };
    'app/org/settings/webhooks': { organizationId: string };
    'app/org/usage': { organizationId: string };
    'app/admin/api-keys': {};
    'app/admin/organization-create': {};
    'app/admin/organization-edit': { id: string };
    'app/admin/organization-members': { id: string };
    'app/admin/organizations': {};
    'app/admin/session-stats': {};
    'app/admin/template-create': {};
    'app/admin/template-edit': { id: string };
    'app/admin/templates': {};
    'app/admin/users': {};
    'login': {};
    'login/password-reset': { token?: string };
    'login/reset-request-success': {};
    'login/reset-request': {};
  }
  interface BuzolaPersistentParams {
    organizationId: true;
  }
}

// Page registry — page ID → route pattern
export const pageRegistry: Record<string, string> = {
  'app': '/app',
  'app/org/instances/detail/debug': '/app/org/:organizationId/instances/:id/debug',
  'app/org/instances/detail/debug/agents-detail': '/app/org/:organizationId/instances/:id/debug/:sessionId/agents/:agentId',
  'app/org/instances/detail/debug/agents': '/app/org/:organizationId/instances/:id/debug/:sessionId/agents',
  'app/org/instances/detail/debug/communication': '/app/org/:organizationId/instances/:id/debug/:sessionId/communication',
  'app/org/instances/detail/debug/dashboard': '/app/org/:organizationId/instances/:id/debug/:sessionId/dashboard',
  'app/org/instances/detail/debug/events': '/app/org/:organizationId/instances/:id/debug/:sessionId/events',
  'app/org/instances/detail/debug/files': '/app/org/:organizationId/instances/:id/debug/:sessionId/files',
  'app/org/instances/detail/debug/llm-call': '/app/org/:organizationId/instances/:id/debug/:sessionId/llm-calls/:callId',
  'app/org/instances/detail/debug/llm-calls': '/app/org/:organizationId/instances/:id/debug/:sessionId/llm-calls',
  'app/org/instances/detail/debug/logs': '/app/org/:organizationId/instances/:id/debug/:sessionId/logs',
  'app/org/instances/detail/debug/mailbox': '/app/org/:organizationId/instances/:id/debug/:sessionId/mailbox',
  'app/org/instances/detail/debug/services': '/app/org/:organizationId/instances/:id/debug/:sessionId/services',
  'app/org/instances/detail/debug/timeline': '/app/org/:organizationId/instances/:id/debug/:sessionId/timeline',
  'app/org/instances/detail/debug/user-chat': '/app/org/:organizationId/instances/:id/debug/:sessionId/user-chat',
  'app/org/bundles/edit': '/app/org/:organizationId/bundles/:id',
  'app/org/bundles': '/app/org/:organizationId/bundles',
  'app/org/instances/create': '/app/org/:organizationId/instances/create',
  'app/org/instances/detail': '/app/org/:organizationId/instances/:id',
  'app/org/instances': '/app/org/:organizationId/instances',
  'app/org/members': '/app/org/:organizationId/members',
  'app/org/resources/edit': '/app/org/:organizationId/resources/:id',
  'app/org/resources': '/app/org/:organizationId/resources',
  'app/org/settings/api-key-create': '/app/org/:organizationId/settings/api-keys/create',
  'app/org/settings/api-keys': '/app/org/:organizationId/settings/api-keys',
  'app/org/settings/general': '/app/org/:organizationId/settings/general',
  'app/org/settings/github': '/app/org/:organizationId/settings/github',
  'app/org/settings': '/app/org/:organizationId/settings',
  'app/org/settings/providers': '/app/org/:organizationId/settings/providers',
  'app/org/settings/webhooks': '/app/org/:organizationId/settings/webhooks',
  'app/org/usage': '/app/org/:organizationId/usage',
  'app/admin/api-keys': '/app/admin/api-keys',
  'app/admin/organization-create': '/app/admin/organizations/create',
  'app/admin/organization-edit': '/app/admin/organizations/:id',
  'app/admin/organization-members': '/app/admin/organizations/:id/members',
  'app/admin/organizations': '/app/admin/organizations',
  'app/admin/session-stats': '/app/admin/session-stats',
  'app/admin/template-create': '/app/admin/templates/create',
  'app/admin/template-edit': '/app/admin/templates/:id',
  'app/admin/templates': '/app/admin/templates',
  'app/admin/users': '/app/admin/users',
  'login': '/',
  'login/password-reset': '/login/password-reset',
  'login/reset-request-success': '/login/reset-request-success',
  'login/reset-request': '/login/reset-request',
};

const routeConfigs: RouteConfig[] = [
  {
    path: '/',
    component: Route0,
    isLayout: true,
    children: [
      {
        path: '/app',
        component: Route1,
        isLayout: true,
        children: [
          {
            path: '/',
            component: lazy(Route2),
            isIndex: true,
          },
          {
            path: '/org',
            component: Route3,
            isLayout: true,
            children: [
              {
                path: '/instances/detail/debug',
                component: Route4,
                isLayout: true,
                children: [
                  {
                    path: '/',
                    matchPath: '/app/org/:organizationId/instances/:id/debug',
                    component: lazy(Route5),
                    isIndex: true,
                  },
                  {
                    path: '/agents-detail',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/agents/:agentId',
                    component: lazy(Route6),
                  },
                  {
                    path: '/agents',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/agents',
                    component: lazy(Route7),
                  },
                  {
                    path: '/communication',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/communication',
                    component: lazy(Route8),
                  },
                  {
                    path: '/dashboard',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/dashboard',
                    component: lazy(Route9),
                  },
                  {
                    path: '/events',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/events',
                    component: lazy(Route10),
                  },
                  {
                    path: '/files',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/files',
                    component: lazy(Route11),
                  },
                  {
                    path: '/llm-call',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/llm-calls/:callId',
                    component: lazy(Route12),
                  },
                  {
                    path: '/llm-calls',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/llm-calls',
                    component: lazy(Route13),
                  },
                  {
                    path: '/logs',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/logs',
                    component: lazy(Route14),
                  },
                  {
                    path: '/mailbox',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/mailbox',
                    component: lazy(Route15),
                  },
                  {
                    path: '/services',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/services',
                    component: lazy(Route16),
                  },
                  {
                    path: '/timeline',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/timeline',
                    component: lazy(Route17),
                  },
                  {
                    path: '/user-chat',
                    matchPath: '/app/org/:organizationId/instances/:id/debug/:sessionId/user-chat',
                    component: lazy(Route18),
                  },
                ],
              },
              {
                path: '/bundles/edit',
                matchPath: '/app/org/:organizationId/bundles/:id',
                component: lazy(Route19),
              },
              {
                path: '/bundles',
                matchPath: '/app/org/:organizationId/bundles',
                component: lazy(Route20),
              },
              {
                path: '/instances/create',
                matchPath: '/app/org/:organizationId/instances/create',
                component: lazy(Route21),
              },
              {
                path: '/instances/detail',
                matchPath: '/app/org/:organizationId/instances/:id',
                component: lazy(Route22),
              },
              {
                path: '/instances',
                matchPath: '/app/org/:organizationId/instances',
                component: lazy(Route23),
              },
              {
                path: '/members',
                matchPath: '/app/org/:organizationId/members',
                component: lazy(Route24),
              },
              {
                path: '/resources/edit',
                matchPath: '/app/org/:organizationId/resources/:id',
                component: lazy(Route25),
              },
              {
                path: '/resources',
                matchPath: '/app/org/:organizationId/resources',
                component: lazy(Route26),
              },
              {
                path: '/settings/api-key-create',
                matchPath: '/app/org/:organizationId/settings/api-keys/create',
                component: lazy(Route27),
              },
              {
                path: '/settings/api-keys',
                matchPath: '/app/org/:organizationId/settings/api-keys',
                component: lazy(Route28),
              },
              {
                path: '/settings/general',
                matchPath: '/app/org/:organizationId/settings/general',
                component: lazy(Route29),
              },
              {
                path: '/settings/github',
                matchPath: '/app/org/:organizationId/settings/github',
                component: lazy(Route30),
              },
              {
                path: '/settings',
                matchPath: '/app/org/:organizationId/settings',
                component: lazy(Route31),
              },
              {
                path: '/settings/providers',
                matchPath: '/app/org/:organizationId/settings/providers',
                component: lazy(Route32),
              },
              {
                path: '/settings/webhooks',
                matchPath: '/app/org/:organizationId/settings/webhooks',
                component: lazy(Route33),
              },
              {
                path: '/usage',
                matchPath: '/app/org/:organizationId/usage',
                component: lazy(Route34),
              },
            ],
          },
          {
            path: '/admin',
            component: Route35,
            isLayout: true,
            children: [
              {
                path: '/api-keys',
                component: lazy(Route36),
              },
              {
                path: '/organization-create',
                matchPath: '/app/admin/organizations/create',
                component: lazy(Route37),
              },
              {
                path: '/organization-edit',
                matchPath: '/app/admin/organizations/:id',
                component: lazy(Route38),
              },
              {
                path: '/organization-members',
                matchPath: '/app/admin/organizations/:id/members',
                component: lazy(Route39),
              },
              {
                path: '/organizations',
                component: lazy(Route40),
              },
              {
                path: '/session-stats',
                component: lazy(Route41),
              },
              {
                path: '/template-create',
                matchPath: '/app/admin/templates/create',
                component: lazy(Route42),
              },
              {
                path: '/template-edit',
                matchPath: '/app/admin/templates/:id',
                component: lazy(Route43),
              },
              {
                path: '/templates',
                component: lazy(Route44),
              },
              {
                path: '/users',
                component: lazy(Route45),
              },
            ],
          },
        ],
      },
      {
        path: '/login',
        component: Route46,
        isLayout: true,
        children: [
          {
            path: '/',
            matchPath: '/',
            component: lazy(Route47),
            isIndex: true,
          },
          {
            path: '/password-reset',
            component: lazy(Route48),
          },
          {
            path: '/reset-request-success',
            component: lazy(Route49),
          },
          {
            path: '/reset-request',
            component: lazy(Route50),
          },
        ],
      },
    ],
  },
];

export const routes = buildRouteTree(routeConfigs);
